import React from 'react';
import { Button } from '@mui/material';

interface PartnerPayButtonProps {
  label: string;
  link: string;
}

const PartnerPayButton: React.FunctionComponent<PartnerPayButtonProps> = ({ link, label }) => {
  return (
    <Button variant={'contained'} color={'secondary'} target={'_blank'} href={link}>
      {label}
    </Button>
  );
};

export default PartnerPayButton;
